import React from "react";

const MOTIF = `
<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'>
  <g fill='none' stroke='#C6A15B' stroke-width='1.3'>
    <path d='M20 4 C10 4 4 14 12 22 C16 26 22 24 22 18 C22 14 17 12 15 15 C13 18 16 22 20 22 C28 22 32 14 26 8 C24 6 20 4 20 4 Z' />
    <circle cx='20' cy='4' r='1.6' fill='#C6A15B' stroke='none' />
  </g>
</svg>
`;

const motifUrl = `data:image/svg+xml,${encodeURIComponent(MOTIF)}`;

export default function SectionDivider({ tone = "gold" }) {
  const lineClass = tone === "ivory" ? "bg-cream-100/50" : "bg-gold-500/60";

  return (
    <div className="flex items-center justify-center gap-5 py-2" aria-hidden="true">
      <span className={`h-px w-20 sm:w-32 ${lineClass}`} />
      <img src={motifUrl} alt="" className="h-6 w-6 opacity-80" />
      <span className={`h-px w-20 sm:w-32 ${lineClass}`} />
    </div>
  );
}
